<template>
  <div>
    <div class="row">
      <div class="col">
        <b-card>
          <div
            class="row"
            v-if="selectedAccount && selectedAccount.accountable"
          >
            <div class="col-8">
              <h3 class="m-0 p-0">
                {{ selectedAccount.accountable.name }}
                <span v-if="selectedAccount.accountable.surname">{{
                  selectedAccount.accountable.surname
                }}</span>
              </h3>
              <p class="text-primary" v-if="selectedAccount">
                {{ selectedAccount.accountable_type.replace("App\\", "") }}
              </p>
            </div>
            <div class="col-4 text-right">
              <button class="btn btn-info text-white">
                {{ selectedAccount.current_balance | currency }}
              </button>
              <span
                class="btn btn-danger"
                v-if="selectedAccount.accountable.deleted_at != null"
                >Deleted</span
              >
            </div>
          </div>

          <b-tabs v-if="selectedAccount">
            <b-tab
              title="Invoices"
              v-if="selectedAccount.account_type == 'Receivable'"
            >
              <invoices :accountId="selectedAccount.id" :key="accountChanged" />
            </b-tab>
            <b-tab
              title="Goods Received"
              v-if="selectedAccount.account_type == 'Payable'"
            >
              <goods-received
                :accountId="selectedAccount.id"
                :key="accountChanged"
              />
            </b-tab>
            <b-tab title="Payments">
              <payments :accountId="selectedAccount.id" @updated="refresh" />
            </b-tab>
            <b-tab title="Credits">
              <credits :accountId="selectedAccount.id" @updated="refresh" />
            </b-tab>
            <b-tab title="Debits">
              <debits :accountId="selectedAccount.id" @updated="refresh" />
            </b-tab>
            <b-tab title="Statement">
              <statement
                :accountId="selectedAccount.id"
                :key="accountChanged"
              />
            </b-tab>
            <b-tab
              title="Current Jobs"
              v-if="selectedAccount.accountable.current_jobs"
            >
              <table class="table table-sm">
                <thead>
                  <tr>
                    <th>Job</th>
                    <th>Status</th>
                    <th>Location</th>
                    <th></th>
                  </tr>
                </thead>
                <tr
                  v-for="job in selectedAccount.accountable.current_jobs"
                  :key="job.id"
                >
                  <td>#{{ job.job_number }}</td>
                  <td>{{ job.job_status_location.status }}</td>
                  <td>{{ job.job_status_location.location }}</td>
                  <td class="text-right">
                    <router-link
                      v-b-tooltip.hover
                      title="view"
                      :to="{
                        name: 'jobs-enquiry-detailed',
                        params: { id: job.id },
                      }"
                      class="text-info table-action-icon"
                    >
                      <i class="lni lni-search-alt"></i>
                    </router-link>
                  </td>
                </tr>
              </table>
            </b-tab>


            <b-tab
              title="Supplier"
              v-if="selectedAccount.accountable_type == 'App\\Supplier'"
            >

            <table class="table">
              <table-row label="Name" :noBorder="true">
                {{ selectedAccount.accountable.name }}
              </table-row>

             

              <table-row label="Contact Number">
                {{ selectedAccount.accountable.contact_number }}
              </table-row>

              <table-row label="Contact Number 2">
                {{ selectedAccount.accountable.contact_number_2 }}
              </table-row>

              <table-row label="Email">
                {{ selectedAccount.accountable.email_address }}
              </table-row>

              <table-row label="Physical Address">
                {{ selectedAccount.accountable.physical_address }}
              </table-row>

              <table-row label="Postal Address">
                {{ selectedAccount.accountable.postal_address }}
              </table-row>

            

             
            </table>
            </b-tab>




            <b-tab
              title="Client"
              v-if="selectedAccount.accountable_type == 'App\\Client'"
            >
              <table class="table">
                <table-row
                  label="Name"
                  :noBorder="true"
                  :copyText="selectedAccount.accountable.name"
                >
                  {{ selectedAccount.accountable.name }}
                </table-row>

                <table-row label="Surname" :copyText="selectedAccount.accountable.surname">
                  {{ selectedAccount.accountable.surname }}
                </table-row>

                <table-row label="Type">
                  {{ selectedAccount.accountable.client_type }}
                </table-row>

                <table-row label="ID Number" v-if="selectedAccount.accountable.id_number">
                  {{ selectedAccount.accountable.id_number }}
                </table-row>

                <table-row
                  label="Contact Number"
                  :copyText="selectedAccount.accountable.contact_number"
                >
                  {{ selectedAccount.accountable.contact_number }}
                </table-row>

                <table-row
                  label="Contact Number 2"
                  v-if="selectedAccount.accountable.contact_number_2"
                >
                  {{ selectedAccount.accountable.contact_number_2 }}
                </table-row>

                <table-row label="Email" :copyText="selectedAccount.accountable.email_address">
                  {{ selectedAccount.accountable.email_address }}
                </table-row>

                <table-row
                  label="Address"
                  class="nl2br"
                  :copyText="selectedAccount.accountable.address"
                  >{{ selectedAccount.accountable.address }}</table-row
                >

                <table-row label="City" :copyText="selectedAccount.accountable.city">
                  {{ selectedAccount.accountable.city }}
                </table-row>

                <table-row label="Postal Code" :copyText="selectedAccount.accountable.postal_code">
                  {{ selectedAccount.accountable.postal_code }}
                </table-row>

                <table-row
                  label="Province"
                  v-if="selectedAccount.accountable.province"
                  :copyText="selectedAccount.accountable.province.province"
                >
                  {{ selectedAccount.accountable.province.province }}
                </table-row>

                <table-row label="Vat #" v-if="selectedAccount.accountable.vat_number">
                  {{ selectedAccount.accountable.vat_number }}
                </table-row>

                <table-row label="Notes">
                  {{ selectedAccount.accountable.notes }}
                </table-row>
              </table>
            </b-tab>




            <b-tab
              title="Partner"
              v-if="selectedAccount.accountable_type == 'App\\Partner'"
            >
             <table class="table">
              <table-row label="Insurance Jobs" :noBorder="true">
                <i
                  class="lni lni-checkmark-circle text-success"
                  v-if="selectedAccount.accountable.is_insurance_jobs == 1"
                ></i>
                <i
                  class="lni lni-cross-circle text-danger"
                  v-if="selectedAccount.accountable.is_insurance_jobs == 0"
                ></i>
              </table-row>

              <table-row label="Shipping Required">
                <i
                  class="lni lni-checkmark-circle text-success"
                  v-if="selectedAccount.accountable.is_shipping_required == 1"
                ></i>
                <i
                  class="lni lni-cross-circle text-danger"
                  v-if="selectedAccount.accountable.is_shipping_required == 0"
                ></i>
              </table-row>

              <table-row label="Code">
                {{ selectedAccount.accountable.code }}
              </table-row>

              <table-row label="Name" :copyText="selectedAccount.accountable.name">
                {{ selectedAccount.accountable.name }}
              </table-row>

              <table-row label="Type">
                {{ selectedAccount.accountable.partner_type }}
              </table-row>

             

              <table-row
                label="Contact Number"
                :copyText="selectedAccount.accountable.contact_number"
              >
                {{ selectedAccount.accountable.contact_number }}
              </table-row>

              <table-row label="Contact Number 2">
                {{ selectedAccount.accountable.contact_number_2 }}
              </table-row>

              <table-row label="Email" :copyText="selectedAccount.accountable.email_address">
                {{ selectedAccount.accountable.email_address }}
              </table-row>

              <table-row
                label="Email Jobs"
                :copyText="selectedAccount.accountable.email_address_jobs"
              >
                {{ selectedAccount.accountable.email_address_jobs }}
              </table-row>

              <table-row
                label="Email Accounts"
                :copyText="selectedAccount.accountable.email_address_accounts"
              >
                {{ selectedAccount.accountable.email_address_accounts }}
              </table-row>

              <table-row
                label="Address"
                class="nl2br"
                :copyText="selectedAccount.accountable.address"
              >
                {{ selectedAccount.accountable.address }}
              </table-row>

              <table-row label="City" :copyText="selectedAccount.accountable.city">
                {{ selectedAccount.accountable.city }}
              </table-row>

              <table-row label="Postal Code" :copyText="selectedAccount.accountable.postal_code">
                {{ selectedAccount.accountable.postal_code }}
              </table-row>

              <table-row
                label="Province"
                v-if="selectedAccount.accountable.province"
                :copyText="selectedAccount.accountable.province.province"
              >
                {{ selectedAccount.accountable.province.province }}
              </table-row>

              <table-row label="Vat #">
                {{ selectedAccount.accountable.vat_number }}
              </table-row>

              <table-row label="Registration #">
                {{ selectedAccount.accountable.registration_number }}
              </table-row>

              <table-row label="FSP #">
                {{ selectedAccount.accountable.fsp_number }}
              </table-row>

              <table-row label="Notes" class="nl2br">
                {{ selectedAccount.accountable.notes }}
              </table-row>

            

             
            </table>
            </b-tab>
          </b-tabs>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import accountRepo from "@/api/repos/accountRepo";
import invoices from "@/views/modules/accounts/accountInvoices";
import goodsReceived from "@/views/modules/accounts/accountGrvs";
import payments from "@/views/modules/accounts/accountPayments";
import debits from "@/views/modules/accounts/accountDebits";
import credits from "@/views/modules/accounts/accountCredits";
import statement from "@/views/modules/accounts/accountStatement";
import tableRow from "@/components/common/TableRow";

export default {
  props: ["id"],

  components: {
    invoices,
    goodsReceived,
    payments,
    debits,
    credits,
    statement,
    tableRow
  },
  data() {
    return {
      accountChanged: 1,
      accounts: [],
      selectedAccount: null,
      loading: false,
    };
  },

  mounted() {
    this.getAccount();
  },

  methods: {
    async getAccount() {
      this.loading = true;
      try {
        let { data } = await accountRepo.get(this.id);
        this.selectedAccount = data.account;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    refresh() {
      this.getAccount();
      this.accountChanged = this.accountChanged + 1;
    },
  },
};
</script>

<style>
</style>